import { Button } from '@Infowijs-eng/component-library/components'
import { Pencil, TrashBin } from '@Infowijs-eng/component-library/icons'
import { usePromisifyDispatch } from '@Infowijs-eng/component-library/modules'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import updateCustomerProduct from '../../actions/customerProducts/updateCustomerProduct'
import fetchCustomerProduct from '../../actions/customerProducts/fetchCustomerProduct'

interface ExporterListItemProps {
  title: string
  subtitle?: string
}

export default function ExporterListItem({
  title, subtitle = undefined,
}: ExporterListItemProps) {
  const promisifyDispatch = usePromisifyDispatch()
  const dispatch = useDispatch()
  const { customerProductId } = useParams()

  return (
    <div className="flex flex-row justify-between w-full h-16 items-center pl-4">
      <div>
        <div className="font-bold text-sm">{title}</div>
        {subtitle && <div className="text-sm">{subtitle}</div>}
      </div>
      <div className="flex flex-row gap-1">
        <Button
          small
          neutral
          leadingAddon={
            <Pencil />
          }
          to="exporters/edit"
        >
          Edit
        </Button>
        <Button
          small
          neutral
          leadingAddon={
            <TrashBin />
          }
          onClick={() => {
            if (!customerProductId) {
              return
            }

            // eslint-disable-next-line no-alert
            if (!window.confirm('Are you sure you want to delete this exporter?')) {
              return
            }

            promisifyDispatch(updateCustomerProduct({
              id: customerProductId,
              metadata: {
                exporters: {
                  somtoday: null,
                  magister: null,
                },
              },
            })).then(() => {
              dispatch(fetchCustomerProduct(customerProductId))
            })
          }}
        >
          Delete
        </Button>
      </div>

    </div>
  )
}
